(function () {
  function normalizeRoot(root) {
    var normalized = root || '/';
    if (normalized.charAt(0) !== '/') normalized = '/' + normalized;
    if (normalized.charAt(normalized.length - 1) !== '/') normalized += '/';
    return normalized;
  }

  function localizePath(root, path) {
    return normalizeRoot(root) + String(path || '').replace(/^\/+/, '');
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function sameOriginPath(link) {
    if (!link) return '';

    try {
      var url = new URL(link.getAttribute('href') || '', window.location.href);
      if (url.origin !== window.location.origin) return '';
      return url.pathname.replace(/\/+$/, '') || '/';
    } catch (error) {
      return '';
    }
  }

  function pathEndsWith(link, suffix) {
    var path = sameOriginPath(link);
    return path && path.endsWith(suffix);
  }

  function applyRootLinks(root) {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var rawPath = link.getAttribute('href') || '';

      if (
        rawPath === '/search' ||
        rawPath === '/cart' ||
        rawPath.indexOf('/account') === 0
      ) {
        link.setAttribute('href', localizePath(root, rawPath));
      }
    });

    var searchForms = document.querySelectorAll(
      'form[action="/search"], predictive-search form[action="/search"]'
    );

    searchForms.forEach(function (form) {
      form.setAttribute('action', localizePath(root, '/search'));
    });
  }

  function localizeMainContentLinks(root) {
    document.querySelectorAll('#MainContent a[href]').forEach(function (link) {
      var rawPath = link.getAttribute('href') || '';
      var resourcePrefixes = ['/collections/', '/pages/', '/products/', '/policies/', '/blogs/'];
      var shouldLocalize = resourcePrefixes.some(function (prefix) {
        return rawPath.indexOf(prefix) === 0;
      });

      if (shouldLocalize) {
        link.setAttribute('href', localizePath(root, rawPath));
      }
    });
  }

  function replaceHref(link, root, path) {
    if (!link) return;
    link.setAttribute('href', localizePath(root, path));
  }

  function ensureHomepageGameCardStyles() {
    if (document.getElementById('shopponi-home-tcg-card-links-style')) return;

    var style = document.createElement('style');
    style.id = 'shopponi-home-tcg-card-links-style';
    style.textContent =
      '.shopponi-home-tcg-card-link{display:none}' +
      '@media screen and (max-width:749px){' +
      '.shopponi-home-tcg-card-link{' +
      'display:block;position:absolute;inset:0;z-index:3;' +
      '}' +
      '}';
    document.head.appendChild(style);
  }

  function groupHasVisualMedia(group) {
    return Array.from(group.children).some(function (child) {
      return (
        child.classList &&
        child.classList.contains('group-block__media-wrapper') &&
        !child.classList.contains('media--empty') &&
        !child.classList.contains('none')
      );
    });
  }

  function findVisualGroup(link, boundary) {
    var group = link.closest('.group-block');

    while (group && boundary.contains(group)) {
      if (groupHasVisualMedia(group)) return group;

      var parent = group.parentElement;
      group = parent ? parent.closest('.group-block') : null;
    }

    return null;
  }

  function ensureMobileGameCardLink(group, href, label) {
    var nativeLink = Array.from(group.children).find(function (child) {
      return child.matches && child.matches('a.group-block__link');
    });
    var overlay = Array.from(group.children).find(function (child) {
      return child.matches && child.matches('a.shopponi-home-tcg-card-link');
    });

    if (nativeLink) {
      nativeLink.setAttribute('href', href);
      nativeLink.setAttribute('aria-label', label);
      if (overlay) overlay.remove();
      return;
    }

    if (!overlay) {
      overlay = document.createElement('a');
      overlay.className = 'shopponi-home-tcg-card-link';
      group.appendChild(overlay);
    }

    overlay.setAttribute('href', href);
    overlay.setAttribute('aria-label', label);
  }

  function findGameSection(gamePaths) {
    return Array.from(document.querySelectorAll('.shopify-section')).find(function (section) {
      var matches = Array.from(section.querySelectorAll('a[href]')).filter(function (link) {
        return Boolean(gamePaths[normalizeText(link.textContent)]);
      }).length;

      return matches >= 5;
    });
  }

  function fixHomepageLinks(root) {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var gamePaths = {
      'pokemon': '/pages/pokemon-tcg',
      'magic: the gathering': '/pages/magic-the-gathering',
      'one piece': '/pages/one-piece-card-game',
      'riftbound': '/pages/riftbound-tcg',
      'dragon ball': '/pages/dragon-ball-super-card-game',
      'final fantasy': '/pages/final-fantasy-tcg',
      'lorcana': '/pages/disney-lorcana-tcg',
      'star wars unlimited': '/pages/star-wars-unlimited',
      'digimon': '/pages/digimon-card-game',
      'yu-gi-oh!': '/pages/yu-gi-oh'
    };

    var gamesSection = findGameSection(gamePaths);
    if (gamesSection) {
      ensureHomepageGameCardStyles();

      Array.from(gamesSection.querySelectorAll('a[href]')).forEach(function (link) {
        var rawLabel = String(link.textContent || '').trim();
        var label = normalizeText(rawLabel);

        if (gamePaths[label]) {
          replaceHref(link, root, gamePaths[label]);

          var group = findVisualGroup(link, gamesSection);
          if (group) {
            ensureMobileGameCardLink(group, link.getAttribute('href'), rawLabel);
          }
        }
      });
    }

  }

  function setCatalogNavActiveState() {
    if (!document.body || !document.body.classList.contains('template-collection')) return;

    var navLinks = document.querySelectorAll('.shopponi-catalog-nav__links a');
    if (!navLinks.length) return;

    var path = window.location.pathname.replace(/\/+$/, '');
    var segments = path.split('/').filter(Boolean);
    var collectionsIndex = segments.lastIndexOf('collections');

    if (collectionsIndex === -1 || !segments[collectionsIndex + 1]) return;

    var handle = decodeURIComponent(segments[collectionsIndex + 1]).toLowerCase();
    var groupPath = '';

    if (handle === 'prodotti-sigillati' || handle.indexOf('sigillati-') === 0) {
      groupPath = '/collections/prodotti-sigillati';
    } else if (handle === 'accessori-tcg' || handle.indexOf('accessori-') === 0) {
      groupPath = '/collections/accessori-tcg';
    }

    navLinks.forEach(function (link) {
      var isActive = groupPath ? pathEndsWith(link, groupPath) : link.classList.contains('is-active');

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function applyLocalizedLinks() {
    var root = normalizeRoot(
      window.Shopify && Shopify.routes ? Shopify.routes.root : '/'
    );

    applyRootLinks(root);
    localizeMainContentLinks(root);
    fixHomepageLinks(root);
    setCatalogNavActiveState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLocalizedLinks);
  } else {
    applyLocalizedLinks();
  }

  document.addEventListener('shopify:section:load', applyLocalizedLinks);
})();
